import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { ComponentWrapper, Toggle } from 'ascential-horizon'
import {
  LiveContainer,
  LiveWrapper,
  LiveTitleWrap,
  ToggleWrapper,
} from './LivePlayer.style'
import VideoEmbed from './VideoEmbed'
import SlidoEmbed from './SlidoEmbed'
import { trackBtnClick } from '../../services/tracking'
import VotemoEmbed from './VotemoEmbed'

function LivePlayerContent({
  interactionTool,
  isAuthorized,
  liveTitleUrl,
  loggedIn,
  login,
  slido,
  user,
  videoUrl,
  votemo,
}) {
  const [chatToggle, setChatToggle] = useState(false)
  const showChat = !chatToggle
  const splitSlido =
    slido.url && isAuthorized && showChat && interactionTool === 'Slido'
  const splitVotemo =
    votemo.url && isAuthorized && showChat && interactionTool === 'Votemo'
  const splitLogic = splitSlido || splitVotemo
  const showToggle =
    (slido.url && interactionTool === 'Slido') ||
    (votemo.url && interactionTool === 'Votemo')

  const toggleClick = () => {
    trackBtnClick('Toggle Chat', '#', 'toggle.click')
    setChatToggle(!chatToggle)
  }

  const hasSlido = interactionTool === 'Slido' && !!slido.url
  const hasVotemo = interactionTool === 'Votemo' && !!votemo.url

  return (
    <ComponentWrapper columnWidth={[12]}>
      <LiveContainer>
        {isAuthorized && showToggle && (
          <ToggleWrapper>
            <Toggle
              checked={chatToggle}
              handleToggle={toggleClick}
              id="liveplayer-toggle"
              label="Hide chat"
            />
          </ToggleWrapper>
        )}
        <LiveWrapper>
          {videoUrl ? (
            <VideoEmbed
              isAuthorized={isAuthorized}
              login={login}
              loggedIn={loggedIn}
              splitLogic={splitLogic}
              url={videoUrl}
              hasVotemo={hasVotemo}
            />
          ) : (
            <h3>Come again later, We don have the live show URL</h3>
          )}

          {isAuthorized && hasSlido && <SlidoEmbed user={user} {...slido} />}

          {isAuthorized && hasVotemo && (
            <VotemoEmbed user={user} hasVotemo={hasVotemo} {...votemo} />
          )}
        </LiveWrapper>

        {liveTitleUrl && (
          <LiveTitleWrap
            title="Video Title"
            src={liveTitleUrl}
            frameBorder="0"
          />
        )}
      </LiveContainer>
    </ComponentWrapper>
  )
}

LivePlayerContent.propTypes = {
  interactionTool: PropTypes.oneOf(['Slido', 'Votemo']),
  isAuthorized: PropTypes.bool,
  liveTitleUrl: PropTypes.string,
  login: PropTypes.func,
  loggedIn: PropTypes.bool,
  slido: PropTypes.shape({
    url: PropTypes.string,
    slidoUrl: PropTypes.string,
  }),
  user: PropTypes.shape({
    email: PropTypes.string,
    firstName: PropTypes.string,
    company: PropTypes.string,
    loggedIn: PropTypes.bool,
  }),
  videoUrl: PropTypes.string.isRequired,
  votemo: PropTypes.shape({
    url: PropTypes.string,
  }),
}

LivePlayerContent.defaultProps = {
  interactionTool: null,
  isAuthorized: false,
  liveTitleUrl: null,
  login: () => {},
  loggedIn: false,
  slido: {},
  user: {},
  votemo: {},
}

export default LivePlayerContent
